import React from "react";
import { Form, Row, Col } from "react-bootstrap";

export default function AddressTab() {
  return (
    <Row>
      <Col md={12}>
        <Form.Group>
          <Form.Label>Address *</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>Country *</Form.Label>
          <Form.Select><option>Select</option></Form.Select>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>State *</Form.Label>
          <Form.Select><option>Select</option></Form.Select>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>City *</Form.Label>
          <Form.Select><option>Select</option></Form.Select>
        </Form.Group>
      </Col>

      <Col md={6}>
        <Form.Group>
          <Form.Label>Zipcode *</Form.Label>
          <Form.Control />
        </Form.Group>
      </Col>
    </Row>
  );
}